<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Reallocate pallet</strong>           
          </div>
          <div class="box" id="addform">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              


              <b-row>



                <b-col md="5" >
                  <b-col sm="12" >
                   <b-form-group label=" From Delivery Agent"  :label-cols="4" >
                  <!--   <b-form-select v-model="customer.deliveryagentmasterid" name="deliveryagentname" v-on:change="getfrompallet()"  v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.deliveryagentmasterid" v-for="customer in data1" >{{ customer.deliveryagentmasterid }}-{{ customer.deliveryagentfirstname | capitalize }}- {{ customer.deliveryagentlastname | capitalize }} - {{ customer.deliveryagentmobilenumber }}</option>
                    </b-form-select>  -->
             <v-select id="mySelect" v-model="customer.deliveryagentmasterid" :options="this.data1"  name="deliveryagentname" v-on:change="getfrompallet()" v-validate="'required'" :class="{ danger: errors.has('deliveryagentname') }">
                      </v-select>
                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span>
                  </b-form-group>
                </b-col>
             </b-col>
                
           <b-col md="5">
                   <b-form-group label=" From Pallet "  :label-cols="4" >
                   <!--  <b-form-select v-model="customer.pallet_id" id="customer.pallet_id" 
                    name="pallet" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.pallet') }" >
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.pallet_id" v-for="customer in data">{{ customer.pallet_title }}</option>

                    </b-form-select>  -->
                    <v-select id="mySelect" v-model="customer.pallet_id" :options="this.data"  name="pallet" v-validate="'required'" :class="{ danger: errors.has('pallet') }">
                      </v-select>

                    <span style="width: 270px;" v-show="errors.has('form-1.pallet')" class="help text-danger">{{ errors.first('form-1.pallet') }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
             
                  <b-col md="5" >
                    <b-col sm="12" >
                   <b-form-group label=" To Delivery Agent"  :label-cols="4" >
                   <!--  <b-form-select v-model="customer.deliveryagentmasteridto" name="deliveryagentnameto" v-on:change="gettopallet()" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentnameto') }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.deliveryagentmasterid" v-for="customer in data1"  >{{ customer.deliveryagentmasterid }}-{{ customer.deliveryagentfirstname | capitalize }}- {{ customer.deliveryagentlastname | capitalize }} - {{ customer.deliveryagentmobilenumber }}</option>
                    </b-form-select>  -->
                     <v-select id="mySelect" v-model="customer.deliveryagentmasteridto" :options="this.data1"  name="deliveryagentnameto" v-on:change="gettopallet()" v-validate="'required'" :class="{ danger: errors.has('deliveryagentnameto') }">
                      </v-select>
                    <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentnameto')" class="help text-danger">{{ errors.first('form-1.deliveryagentnameto') }}</span>
                  </b-form-group>
                </b-col>
             </b-col>

               <b-col md="5">
                   <b-form-group label=" To Pallet "  :label-cols="4" >
                  <!--   <b-form-select v-model="customer.pallet_idto" id="customer.pallet_id" 
                    name="pallet" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.pallet') }" >
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.pallet_id" v-for="customer in datato">{{ customer.pallet_title }}</option>

                    </b-form-select> --> 
                    <v-select id="mySelect" v-model="customer.pallet_idto" :options="this.datato"  name="pallet" v-validate="'required'" :class="{ danger: errors.has('pallet') }">
                      </v-select>


                    <span style="width: 270px;" v-show="errors.has('form-1.pallet')" class="help text-danger">{{ errors.first('form-1.pallet') }}</span>
                  </b-form-group>
                </b-col>
                
      

              </b-row>




              <b-row>
              
                <b-col>
                  <b-col sm="12" >
                 <b-button   class="mr-4" type="submit" size="md" variant="primary">Reallocate</b-button>
                 <b-button  @click="clear" size="md" variant="danger">Clear</b-button>
               </b-col>
                </b-col>
              </b-row>
           
            </form>
          </div>
           
          
    
        </b-card>  
      </b-col>   
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'

export default {
 
  data: function() {
    return {
      name: 'Reallocatepallet',
      data: [],
      DAPendingStatus: [],
      customer: {},
      toggleInfo: false,
      avoidAddingDuplicates:false,
      
      data1:[],
      
      agentfields: { text: 'name', value: 'id' },
      showSelectAll : true,
      allowCustomValue : true,
     
      datato:[],
      selected:'',
      shippingid: '',
      invalidshipppingid:'',
      

      value:'',
      }
  },
  created: function() {
    this.displaydata()
    //this.getpalletlist();
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // this.toggleInfo = !this.toggleInfo
          this.Reallocatepallet();
        }
      })
    },
    
    //     getpalletlist: function () {
    // //  alert("zone & pin codes");
    // this.isBusy = true;
     
      

    //   this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getpalletrecordslisting`)
    //     .then((result) => {
    //       if (result.body.returnmsg="Successful") {
    //          this.data  = result.body.returnvalue;
    //          console.log(this.data);
           
             
    //       } else {
    //         this.data=[];
            
    //       }
    //     })
    //     .catch((ex) => {
    //       console.log('error-----', ex)
    //     })
    // },
  


  displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      //console.log("hello"+userInfo.sysusermasterid);
     if(userInfo.sysusermasterid==25 || userInfo.sysusermasterid==39)
     {
     
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        usertype:'4',
         hub_id:`${userInfo.pickuplocationmasterid}`,

      }
 this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body
          var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
                });
              });
              this.data1 = data;
         // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
     }
   
     else
     {
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,

      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
                  this.data1 = result.body;

      var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
                });
              });
              this.data1 = data;
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    }
 
      
    },
     Reallocatepallet: function() {
   // alert(" i m in Reallocatepallet")
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
    
     
      let obj = {
      
    

fromriderid:this.customer.deliveryagentmasterid.key,
frompallet_id:this.customer.pallet_id.key,
toriderid:this.customer.deliveryagentmasteridto.key,
topallet_id:this.customer.pallet_idto.key,
// hub_id:`${userInfo.pickuplocationmasterid}`,


       

      }
      // console.log(obj);
      
 this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/palletreallocation`, obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
          //this.data1 = result.body.returnvalue;
           // Utils.notify("Pallet Reallocated Successfully");
            this.$fire({
                  text:"Pallet Reallocated Successfully",
                  type: "success",
                  timer: 30000
                }); 
         }
         else  if (result.body.returnmsg === 'Unsuccessful'){
         // alert(" i m in else")
             
            // Utils.notify(result.body.returnvalue);
            this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
            }
            else if(result.body.returnmsg === 'Fail')
            {
               // Utils.notify(result.body.returnvalue);
                this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
            }
            else
            {
             // Utils.notify(result.body.returnvalue); 
              this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 
            }
         
        })
        .catch((ex) => {
          console.log('error', ex)
        })
     
   
 
 
      
    },
    getfrompallet: function() { 
 //alert("i m in  from pallet");

 
 let obj = {
        deliveryagentmasterid:this.customer.deliveryagentmasterid.key,
        hub_id:`${userInfo.pickuplocationmasterid}`,
     

      }
 this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getallpalletlistforrider`, obj)
        .then((result) => {
         
         if (result.body.returnmsg==="Successful") 
         {
           
             this.data  = result.body.returnvalue;
             //console.log(this.data);
             
            var datafrom = [];
 
              result.body.returnvalue.forEach(function (srData) {
                datafrom.push({
                  key:srData.pallet_id,
                  label:srData.pallet_title,
                });
              });
              this.data = datafrom;

             
           
             
          } 
          else {
           // alert("pallets Are Not Assigned For this Rider");
           this.$fire({
                  text:"Pallets Are Not Assigned For this Rider",
                  type: "warning",
                  timer: 30000
                }); 
             this.data=[];
          }
            
            
       
         
        })
        .catch((ex) => {
          console.log('error', ex)
        })
     
   


     
    
  
    
      },
        gettopallet: function() { 
 //alert("i m in  to pallet");

 let obj = {
        deliveryagentmasterid:this.customer.deliveryagentmasteridto.key,
        hub_id:`${userInfo.pickuplocationmasterid}`,
     

      }
 this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getallpalletlistforrider`, obj)
        .then((result) => {
         if (result.body.returnmsg==="Successful") {
             this.datato  = result.body.returnvalue;
             var data = [];
 
              result.body.returnvalue.forEach(function (srData) {
                data.push({
                  key:srData.pallet_id,
                  label:srData.pallet_title,
                });
              });
              this.datato = data;

             // console.log(this.datato);
           
             
          } 
          else   {

          // alert("pallets Are Not Assigned For this Rider");
           this.$fire({
                  text:"Pallets Are Not Assigned For this Rider",
                  type: "warning",
                  timer: 30000
                }); 
           this.datato =[];
          }
            
            
         
         
        })
        .catch((ex) => {
          console.log('error', ex)
        })
     
   


     
    
  
    
      },
     clear: function () {
      this.tags=[];
      this.customer = {}
      this.customer.pallet_idto="";
      this.invalidshipppingid="";
      this.errors.clear('form-1')
    },
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>
<style >
  .badge-success1
  {
  background-color: #5C6BC0;
    color: #fff;
  }
.badge-success2
  {
  background-color:  #e54d42;
    color: #fff;
  }
  .ti-new-tag-input-wrapper input[data-v-61d92e31] {
    flex: 1 0 auto;
    min-width: 300px;
    height: 100px;
    border: none;
    padding: 0px;
    margin: 0px;
}


</style>

